/**
 * Custom hook for responsive design breakpoints
 * Follows React conventions for custom hooks
 */

import { useState, useEffect } from 'react';
import { ResponsiveBreakpoints } from '../types/auth.types';

export const useResponsiveDesign = (): ResponsiveBreakpoints => {
  const [windowWidth, setWindowWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    windowWidth,
    isMobile: windowWidth < 768,
    isSmallMobile: windowWidth < 480,
    isTablet: windowWidth >= 768 && windowWidth <= 1024,
  };
};